import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Resets the scroll position to the top of the page on every route change.
 *
 * React Router preserves the window scroll offset across client-side
 * navigations, which means following a link from the bottom of one page
 * leaves you mid-way down the next one. Mounting this inside <BrowserRouter>
 * restores the expected "new page starts at the top" behaviour.
 */
export default function ScrollToTop() {
	const { pathname } = useLocation();

	useEffect(() => {
		window.scrollTo(0, 0);
	}, [pathname]);

	return null;
}
